import { SET_DASHBOARD_TITLE } from "./types";

export const setDashboardTitle = title => ({
  type: SET_DASHBOARD_TITLE,
  payload: title,
});
